(function(){
  'use strict';

  angular
    .module('AcaApp')
    .factory('CheckListService', CheckListService);

  CheckListService.$inject = ['$http', '$log', '$q'];

  function CheckListService($http, $log, $q){
    var employerUrl = '/api/employer';
    var correctionUrl = '/api/correction';
    var data = {};
    var service = {
      getData: _getData,
      markAsCompleted: _setMarkAsCompleted,
      getEmployers1094cCorrect: _getEmployers1094cCorrect,
      getEmployers1095Correct: _getEmployers1095Correct
    };

    return service;

    /** @public */
    function _getData(callback, updateShowProperties){
      $q.all([
        _getEmployers(),
        _getEmployers1095(),
        _getIrsReportStatus(),
        _getTransmittalRejection(),
        _getEmployers1095Correct(),
        _getEmployers1094cCorrect()
      ]).then(function(){
        callback(data); // get data from back-end
        updateShowProperties(data); // set view model
      });
    }

    /** @private */
    function _getEmployers(){
      return $http.post(employerUrl, {method: 'GetEmployersNotCompleted', params: []}).then(function(dto){
        return data.employers = dto.data.result;
      }).catch(_fail);
    }

    /** @private */
    function _setMarkAsCompleted(){
      return $http.post(employerUrl, {method: 'MarkEmployersAsCompleted', params: []}).then(function(dto){
        return dto.data.result.value;
      }).catch(_fail);
    }

    /** @private */
    function _getEmployers1095(){
      return $http.post(employerUrl, {method: 'GetEmployers1095ReadyToTransmit', params: []}).then(function(dto){
        return data.transmittals = dto.data.result;
      }).catch(_fail);
    }

    /** @private */
    function _getTransmittalRejection() {
      return $http.post(correctionUrl, {method: 'AreThereTransmittalsRejected', params: []}).then(function(dto){
        return data.rejections = dto.data.result.value === 'Y';
      }).catch(_fail);
    }

    /** @private */
    function _getIrsReportStatus(){
      return $http.post(correctionUrl, {method: 'GetIRSReportStatus', params: []}).then(function(dto){
        return data.irsErrors = dto.data.result.value;
      }).catch(_fail);
    }

    /** @private */
    function _getEmployers1095Correct(){
      return $http.post(employerUrl, {method: 'GetEmployers1095ReadyToCorrect', params: []}).then(function(dto){
        return data.corrections1095 = dto.data.result;
      }).catch(_fail);
    }

    /** @private */
    function _getEmployers1094cCorrect(){
      return $http.post(employerUrl, {method: 'GetEmployers1094CReadyToCorrect', params: []}).then(function(dto){
        return data.corrections1094c = dto.data.result;
      }).catch(_fail);
    }

    function _fail(error){
      $log.log(error);
    }
  }
})();
